import SearchParamsBase from '../../../Elements/SearchParamsBase';

export default class TpClientPaymentTpClientInvoiceSearchParams extends SearchParamsBase {
  static saveType = 'TpClientPaymentTpClientInvoiceSearchParams';
  constructor(tpClientPaymentId, type, typeExtended = '') {
    super();
    this.TpClientPaymentId = tpClientPaymentId;
    this.SearchType = type;
    this.SearchTypeExtended = typeExtended;
  }

  initialize() {}

}
